
import { LinkViewModel } from '@/types/B2BcontentServerContract';
import LinkButton from '@/shared/navigation/LinkButton.vue';
import { defineComponent, PropType, ref, Ref, toRef, watch } from 'vue';

export default defineComponent({
    name: 'Countdown',
    components: { LinkButton },
    props: {
        title: {
            required: false,
            type: String,
            default: '',
        },
        titleBold: {
            type: Boolean,
            default: false,
        },
        expiredText: {
            required: false,
            type: String,
            default: '',
        },
        timer: {
            required: true,
            type: Number,
        },
        link: {
            required: false,
            type: Object as PropType<LinkViewModel>,
            default: () => {},
        },
        smallView: {
            type: Boolean,
            default: false,
        },
    },
    setup(props) {
        const days: Ref<string> = ref('');
        const hours: Ref<string> = ref('');
        const minutes: Ref<string> = ref('');
        const seconds: Ref<string> = ref('');
        const pastTime: Ref<boolean> = ref(false);
        const loaded: Ref<boolean> = ref(false);
        const timer = toRef(props, 'timer');

        const startTimer = () => {
            let stop: number | undefined = setInterval(() => {
                const remaining = timeUntil(timer.value);

                if (remaining.pastTime) {
                    pastTime.value = remaining.pastTime;
                    clearInterval(stop);
                    stop = undefined;
                    loaded.value = true;
                    return;
                }

                days.value = zeroPad(remaining.days, 2);
                hours.value = zeroPad(remaining.hours, 2);
                minutes.value = zeroPad(remaining.minutes, 2);
                seconds.value = zeroPad(remaining.seconds, 2);
                loaded.value = true;
            }, 1000);
        };

        watch(timer, () => {
            pastTime.value = false;
            startTimer();
        }, { immediate: true });

        return {
            days,
            hours,
            minutes,
            seconds,
            pastTime,
            loaded,
        };
    },
});

function timeUntil(date: any) {
    const until: any = {};

    if (date.valueOf() <= new Date().valueOf()) {
        until.pastTime = true;
        return until;
    }

    // get total seconds between the times
    let delta = Math.abs(date.valueOf() - new Date().valueOf()) / 1000;

    // calculate (and subtract) whole days
    until.days = Math.floor(delta / 86400);
    delta -= until.days * 86400;

    // calculate (and subtract) whole hours
    until.hours = Math.floor(delta / 3600) % 24;
    delta -= until.hours * 3600;

    // calculate (and subtract) whole minutes
    until.minutes = Math.floor(delta / 60) % 60;
    delta -= until.minutes * 60;

    // what's left is seconds
    until.seconds = Math.floor(delta % 60);

    return until;
}

function zeroPad(num: any, places: number) {
    const zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join('0') + num;
}
